/**
 * app-search — types + validator for the global search-state of `_app` layout.
 *
 * For now it only centralizes the multi-account flag (`?account=switch`) that opens
 * `AccountSwitcher` (campaign #18). Switcher mounts ONCE at layout level
 * (`AccountSwitcherHost`) and is URL-addressable, so pasting the URL re-opens
 * the overlay. `validateSearch` omits defaults (does not pollute empty URL).
 */

export interface AppLayoutSearch {
  /** Account switcher open (`?account=switch`). Multi-account #18. */
  account?: "switch";
}

export function validateAppLayoutSearch(raw: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};
  if (raw.account === "switch") {
    out.account = "switch";
  }
  return out;
}
